import React, { useState, useRef, useCallback } from 'react';
import { GoogleMap, LoadScript, DrawingManager } from '@react-google-maps/api';

import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { useDispatch, useSelector } from 'react-redux';
import { addUser } from '../../store/usersSlice';
import { useNavigate } from 'react-router-dom';
import { addZone } from '../../store/subscriptionsSlice';
import GoogleMapComponent from './DrawingMapComponent'

function AddZone() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { error } = useSelector((state) => state.users)
    const [validated, setValidated] = useState(false);
    const [name, setName] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [coordinates, setCoordinates] = useState('');
    

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    console.log(form)
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
        setValidated(true);
        event.preventDefault();
        let userObj = {
            name,
            zipcode,
            latitude,
            longitude
        }
        await dispatch(addZone(userObj));
        // navigate('/delivery-zone')
    }
    setValidated(true);
    
  };
    
  return (
    <div className='container'>
        <div className='row mx-5'>
            <Row className='mb-3 mt-3'>
                <h2>Add Zone</h2>
            </Row>
            {
                error ? 
                <Row>
                    <p>Problem in adding Zone!</p>
                </Row>
                : null
            }
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                    <Col sm={2}>
                        <Form.Label className='form_label'> Zone Name </Form.Label>
                    </Col>
                    <Col sm={10}>
                        <Form.Control 
                            type="text" placeholder="Zone Name" required 
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                    <Col sm={2}>
                        <Form.Label className='form_label'> Zipcode </Form.Label>
                    </Col>
                    <Col sm={10}>
                        <Form.Control 
                            type="text" placeholder="Zipcode" required 
                            onChange={(e) => setZipcode(e.target.value)}
                            value={zipcode}
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                    <Col sm={2}>
                        <Form.Label className='form_label'> Latitude </Form.Label>
                    </Col>
                    <Col sm={10}>
                        <Form.Control 
                            type="text" placeholder="Zone Latitude"  
                            onChange={(e) => setLatitude(e.target.value)}
                            value={latitude}
                        />
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                    <Col sm={2}>
                        <Form.Label className='form_label'> Longitude </Form.Label>
                    </Col>
                    <Col sm={10}>
                        <Form.Control 
                            type="text" placeholder="Zone Longitude"  
                            onChange={(e) => setLongitude(e.target.value)}
                            value={longitude}
                        />
                    </Col>
                </Form.Group>
                {/* <Row className='mb-5'>
                    <GoogleMapComponent />
                </Row> */}
                <Button type="submit">Add Zone</Button>
            </Form>
        </div>
    </div>
  );
}

export default AddZone;
